module.exports = __webpack_public_path__ + "logiciel_3d.png?6a6bb05986adf9ff8b68d6089d6a1007";